/**
 * Price forecasts left on symbol pages («پیش‌بینی قیمت»), which go out of date: a forecast older
 * than this is hidden (owner's tech spec 1405-08-13, item 2.10). Comments without a forecast stay.
 */
export const PREDICTION_MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;

/*
 * A forecast is either the labelled form («پیش‌بینی قیمت: … تومان») or the old form of Mehr 1404,
 * stored without labels: "<p> ۱۱۶٬۶۶۱ تومان.<br />\n: reason</p>" (or «… دلار.» on coin pages) (see LEGACY_PREDICTION in
 * `Comment.tsx`, which shows it with labels).
 */
const LABELLED = /پیش[‌ ]?بینی قیمت\s*:/;
const LEGACY = /^\s*<p>\s*[0-9۰-۹٬,.٫]+\s*(?:تومان|دلار)\s*\.?\s*<br\s*\/?>\s*:/;

export const isPrediction = (content?: string): boolean =>
    !!content && (LABELLED.test(content) || LEGACY.test(content));

/** WordPress comment dates are «2025-10-06 13:16:10» in the site's time (Tehran). */
const commentTime = (date?: string): number => {
    if (!date) return NaN;
    const iso = /[zZ]|[+-]\d\d:?\d\d$/.test(date) ? date : `${date.replace(' ', 'T')}+03:30`;
    return Date.parse(iso);
};

export const isStalePrediction = (
    comment: { content?: string; date?: string },
    now: number,
): boolean => {
    if (!isPrediction(comment.content)) return false;
    const time = commentTime(comment.date);
    return Number.isFinite(time) && now - time > PREDICTION_MAX_AGE_MS;
};
